import { render, staticRenderFns } from "./port-list.vue?vue&type=template&id=008068ca&scoped=true&"
import script from "./port-list.vue?vue&type=script&lang=js&"
export * from "./port-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008068ca",
  null
  
)

export default component.exports